<template>
  <div>
    <Headersys />
    <div class="content">
      <!-- 头 -->
      <BsznCurrent :steps="0" :type="2" />
      <div class="section-box">
        <div class="section-card" v-for="item in paginatedData" :key="item.id" @click="chooseTab(item)">
          <div class="section-num">{{ item.idx }}</div>
          <div class="section-title">{{ item.orgName }}</div>
        </div>
      </div>
      <PageSize :total="sectionList.length" :totalPages="totalPages" :currentPage="currentPage"
        @currentChange="currentChange" />
      <Back />
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      //
      sectionList: [],//部门列表
      pageSize: 12,
      currentPage: 1,
      waitTime: 180,
      watiTimer: null
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.sectionList.length / this.pageSize);
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.sectionList.slice(startIndex, endIndex);
    },
  },
  created() {
    //
    this.getBM()
  },
  mounted() {
    //
    this.timeDown()
  },
  destroyed() {
    // console.log('页面销毁');
    clearTimeout(this.watiTimer);
  },
  methods: {
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--
        } else {
          this.waitTime = 180
          clearInterval(this.watiTimer)
          this.$router.back()
        }
      }, 1000);
    },
    chooseTab(item) {
      // item.ORG_CODE
      this.$router.push({
        path: 'sxList',
        query: {
          code: item.orgCode,
          id: item.id,
        }
      })
    },
    //获取部门列表
    getBM() {
      this.$rqt.bfMaster_getDeptAll({
        // regionCode: '370724000000',
        regionCode: '370705000000',
        current: 1,
        size: 10000
      }).then(res => {
        // console.log(res);
        this.sectionList = res.data.records
        this.sectionList.forEach((el, idx) => {
          el.idx = idx + 1
        })
      })
      // this.$rqt.division_sendUrl({
      //   url: 'getItemOrgList',
      //   params: {
      //     regionCode: '370705000000'
      //   }
      // }).then(res => {
      //   this.sectionList = JSON.parse(res.data)
      //   this.sectionList.forEach((el, idx) => {
      //     el.id = idx + 1
      //   })
      //   // console.log(this.sectionList);
      // })
    },
    currentChange(num) {
      if (num == -1) {
        if (this.currentPage == 1) {
          return
        }
        this.currentPage--
      } else if (num == -2) {
        if (this.currentPage == this.totalPages) {
          return
        }
        this.currentPage++
      } else {
        this.currentPage = num
      }
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  padding: 0 5rem;
  background-color: #F1FAFC;
}

.section-box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;

  .section-card {
    width: 49%;
    display: flex;
    align-items: center;
    // border: 1px solid rgba($color: #000000, $alpha: .1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 1rem;
    margin-bottom: 3rem;
    background-color: #fff;

    .section-num {
      width: 12rem;
      height: 12rem;
      line-height: 12rem;
      font-size: 6rem;
      text-align: center;
      color: #fff;
      background-color: #0099FF;
      border-radius: 1rem 0 0 1rem;
      margin-right: 5rem;
    }

    .section-title {
      width: calc(100% - 13rem);
      font-size: 5rem;
    }
  }
}
</style>